import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class IncidenceService extends ApiService {
  constructor(private http: Http) {
    super('api/control-items-errors/', http);
  }

  getTotal(): Observable<any> {
    return this.http
      .get(this.apiUrl + 'api/total-incidences/', { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  switchStatus(id: number): Observable<any> {
    return this.http
      .put(`${this.apiUrl}api/control-item-ignored-switch/${id}/`, {}, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/incidence.service.ts